// @flow

import React, { type Node, type ComponentType, useMemo } from 'react';

export function TextBlock({ children, flavor = 'normal' }: TextBlockProps): Node {
  const Impl = useMemo(() => getTextBlockImpl(flavor), [flavor]);
  return (
    <Impl>
      {children}
    </Impl>
  );
}

type TextBlockProps = {|
  children: Node,
  flavor: Flavor,
|};

function getTextBlockImpl(flavor: Flavor): ComponentType<ErrorTextBlockProps> | string {
  if (flavor === 'error') {
    return ErrorTextBlock;
  }
  return 'p';
}

type ErrorTextBlockProps = {|
  children: Node,
|};

function ErrorTextBlock({ children }: ErrorTextBlockProps): Node {
  return (
    <p className="field__message field__message--error field__label--visible">
      {children}
    </p>
  );
}

type Flavor =
  | 'normal'
  | 'error'
;
